export default function MultiDevice() {
  return (
    <section id="devices" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
            <i className="ri-device-line" />
            多端支持
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
            电脑版 + 手机版，进度无缝同步
          </h2>
          <p className="mt-3 text-base text-foreground-600">
            同一账号登录，阅读进度、订阅与收藏云端同步，走到哪看到哪。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-400 to-accent-400 p-8">
            <div className="relative z-10">
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/20 text-background-50">
                <i className="ri-mac-line text-3xl" />
              </span>
              <h3 className="mt-5 font-heading text-2xl text-background-50">
                香蕉漫画电脑版
              </h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-white/90">
                大屏高清看漫画更过瘾，支持快捷键翻页、批量下载、多标签管理，
                专注追更一整晚不费眼。
              </p>
              <ul className="mt-5 flex flex-wrap gap-2">
                {["大屏高清", "快捷键翻页", "批量缓存", "云端同步"].map((t) => (
                  <li
                    key={t}
                    className="whitespace-nowrap rounded-full bg-white/20 px-3 py-1.5 text-xs text-white"
                  >
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-secondary-400 to-primary-400 p-8">
            <div className="relative z-10">
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/20 text-background-50">
                <i className="ri-smartphone-line text-3xl" />
              </span>
              <h3 className="mt-5 font-heading text-2xl text-background-50">
                香蕉漫画手机版
              </h3>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-white/90">
                为手机深度优化竖屏阅读，单手翻页、自动分格、离线缓存，
                通勤路上也能轻松畅读最新话。
              </p>
              <ul className="mt-5 flex flex-wrap gap-2">
                {["竖屏阅读", "单手翻页", "自动分格", "离线缓存"].map((t) => (
                  <li
                    key={t}
                    className="whitespace-nowrap rounded-full bg-white/20 px-3 py-1.5 text-xs text-white"
                  >
                    {t}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}